import { jsx as s } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import { useTooltip as p } from "./chart-utils.js";
import { Tooltip as e } from "../../tooltip/tooltip.js";
import l from "clsx";
import c from "../chart.module.less.js";
const C = f(
  function({ className: o, style: t, tooltip: m, value: r, ...a }, i) {
    return /* @__PURE__ */ s(
      e,
      {
        as: "div",
        className: l(c.bar, o),
        "data-value": r,
        ref: i,
        style: { ...t, "--value": r },
        ...p(m, r),
        ...a
      }
    );
  }
);
export {
  C as ChartBar
};
//# sourceMappingURL=chart-bar.js.map
